import type { QueryFunctionContext } from '@tanstack/react-query';
import { getMarketFeed } from '@simplywallst/services';
import type { MarketFeedCompanyEvents } from '@/pages/Market/hooks/useMarketFeed';
import type { PrimaryCountryISO } from '@/constants/countries';
import { getCompanyFeedItems } from '@components/Dashboard/hooks/useFeed/selector';
import { formatterCurrency } from '@/utilities/format';

type QueryKey = [string, PrimaryCountryISO, number];

export const getMarketFeedQueryKey = (
  market: PrimaryCountryISO,
  industryId: number
): QueryKey => ['MARKET_FEED', market, industryId];

export default async function fetchMarketFeed({
  queryKey: [_key, market, industryId],
}: QueryFunctionContext<QueryKey>): Promise<
  MarketFeedCompanyEvents[] | undefined
> {
  try {
    const response = await getMarketFeed(market, industryId);
    const companyEvents = response.data.data;
    return companyEvents.map((record) => ({
      name: record.name,
      tickerSymbol: record.ticker_symbol,
      canonicalUrl: record.canonical_url,
      companyId: record.id,
      scores: record.score.data.axes,
      return7D: record.return_7d,
      return1YrAbs: record.return_1yr_abs,
      sharePriceFormatted: formatterCurrency(
        record.last_share_price,
        record.currency_iso
      ),
      feedItems: getCompanyFeedItems(record.events, {
        canonicalUrl: record.canonical_url,
        eventSubRoute: '/watchlist/updates/event/',
      }),
    }));
  } catch (e) {
    if (e instanceof Error) {
      console.error(e.message);
      throw new Error(e.message);
    }
  }
}
